import type { TrackingConsentModeAjax } from './tracking-consent-mode.backend-model';
import type { TrackingConsentMode } from './tracking-consent-mode.model';

export function transformTrackingConsentMode(
  response: TrackingConsentModeAjax,
): TrackingConsentMode {
  return {
    id: response.ip,
    isEnabled: response.isEnabled,
  };
}
